import { SharedModule } from 'src/app/shared/shared.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ConfigurationOptionEffects } from './configuration-option.effects';
import * as fromConfigurationOption from './configuration-option.reducer';
import { ConfigurationOptionSerializer } from './configuration-option.serializer';
import { ConfigurationOptionService } from './configuration-option.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromConfigurationOption.FEATURE_NAME,
      fromConfigurationOption.configurationOptionReducer
    ),
    EffectsModule.forFeature([ConfigurationOptionEffects])
  ],
  declarations: [],
  exports: [],
  providers: [
    ConfigurationOptionService,
    {
      provide: ConfigurationOptionSerializer,
      useClass: ConfigurationOptionSerializer
    }
  ]
})
export class ConfigurationOptionModule {}
